
export default function LegalContent() {
  return (
    <article className="max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-8 pb-4 border-b border-neutral-200">
        <div className="w-10 h-10 flex items-center justify-center bg-neutral-900 text-white rounded-lg">
          <i className="ri-file-shield-2-line text-lg"></i>
        </div>
        <div>
          <h2 className="text-xl font-bold text-neutral-900" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}>
            Aviso Legal
          </h2>
          <p className="text-xs text-neutral-500">Última actualización: Enero 2025</p>
        </div>
      </div>

      <div className="space-y-8 text-neutral-700 text-sm leading-relaxed">
        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#identificacion" className="hover:text-amber-600 transition-colors">1. Identificación del Titular</a>
          </h4>
          <p className="mb-3">
            En cumplimiento de la <strong>Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE)</strong>, se facilitan los siguientes datos del titular del sitio web:
          </p>
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 space-y-2">
            <p><strong>Denominación:</strong> Daro Tattoo</p>
            <p><strong>Actividad:</strong> Estudio profesional de tatuajes personalizados y arte urbano</p>
            <p><strong>Domicilio:</strong> Adra, Almería, España</p>
            <p><strong>Correo electrónico:</strong> info@darotattoo.com</p>
            <p><strong>Sitio web:</strong> darotattoo.com</p>
          </div>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#objeto" className="hover:text-amber-600 transition-colors">2. Objeto del Sitio Web</a>
          </h4>
          <p>
            Este sitio web tiene como finalidad informar sobre los servicios de tatuaje profesional y arte urbano ofrecidos por Daro Tattoo, así como facilitar la reserva de citas y la comunicación con los clientes. El contenido incluye portfolio de trabajos, información sobre el artista, preguntas frecuentes y formularios de contacto.
          </p>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#condiciones" className="hover:text-amber-600 transition-colors">3. Condiciones de Uso</a>
          </h4>
          <p className="mb-3">El acceso y uso de este sitio web implica la aceptación de las siguientes condiciones:</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start gap-2">
              <i className="ri-arrow-right-s-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span>El usuario se compromete a hacer un uso adecuado de los contenidos y servicios ofrecidos</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-arrow-right-s-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span>Queda prohibido el uso del sitio web con fines ilícitos o que perjudiquen a terceros</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-arrow-right-s-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span>El usuario debe ser mayor de 18 años para solicitar servicios de tatuaje</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-arrow-right-s-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span>La información proporcionada en los formularios debe ser veraz y actualizada</span>
            </li>
          </ul>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#propiedad" className="hover:text-amber-600 transition-colors">4. Propiedad Intelectual e Industrial</a>
          </h4>
          <p>
            Todos los contenidos de este sitio web, incluyendo pero no limitándose a textos, fotografías, diseños de tatuajes, ilustraciones, logotipos, nombres comerciales y código fuente, están protegidos por las leyes de <strong>propiedad intelectual e industrial</strong>.
          </p>
          <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center bg-amber-600 text-white rounded shrink-0">
              <i className="ri-error-warning-line text-sm"></i>
            </div>
            <div>
              <p className="font-medium text-amber-900 text-sm mb-1">Importante</p>
              <p className="text-amber-800 text-xs">
                Queda expresamente prohibida la reproducción, distribución, comunicación pública o transformación de los diseños y fotografías de tatuajes sin autorización expresa del artista. Cada diseño es una obra original y única.
              </p>
            </div>
          </div>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#responsabilidad" className="hover:text-amber-600 transition-colors">5. Limitación de Responsabilidad</a>
          </h4>
          <p className="mb-3">Daro Tattoo no se hace responsable de:</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start gap-2">
              <i className="ri-close-circle-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span>Interrupciones en el servicio web por causas técnicas o de fuerza mayor</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-close-circle-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span>Daños derivados del uso inadecuado del sitio web por parte del usuario</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-close-circle-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span>Contenidos de sitios web de terceros a los que se pueda acceder mediante enlaces</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-close-circle-line text-neutral-400 mt-0.5 shrink-0"></i>
              <span>Reacciones alérgicas o complicaciones derivadas del incumplimiento de las instrucciones de cuidado post-tatuaje</span>
            </li>
          </ul>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#servicios" className="hover:text-amber-600 transition-colors">6. Condiciones del Servicio de Tatuaje</a>
          </h4>
          <div className="space-y-3">
            <div className="flex items-start gap-3 bg-neutral-50 rounded-lg p-4 border border-neutral-100">
              <div className="w-8 h-8 flex items-center justify-center bg-neutral-900 text-white rounded shrink-0">
                <i className="ri-money-euro-circle-line text-sm"></i>
              </div>
              <div>
                <p className="font-medium text-neutral-900 text-sm">Señal y Reserva</p>
                <p className="text-xs text-neutral-600 mt-1">Para confirmar una cita se requiere el pago de una señal. Esta señal no es reembolsable en caso de cancelación sin previo aviso con al menos 48 horas de antelación.</p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-neutral-50 rounded-lg p-4 border border-neutral-100">
              <div className="w-8 h-8 flex items-center justify-center bg-neutral-900 text-white rounded shrink-0">
                <i className="ri-calendar-close-line text-sm"></i>
              </div>
              <div>
                <p className="font-medium text-neutral-900 text-sm">Cancelaciones</p>
                <p className="text-xs text-neutral-600 mt-1">Las cancelaciones deben comunicarse con un mínimo de 48 horas de antelación. En caso contrario, se perderá la señal abonada.</p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-neutral-50 rounded-lg p-4 border border-neutral-100">
              <div className="w-8 h-8 flex items-center justify-center bg-neutral-900 text-white rounded shrink-0">
                <i className="ri-heart-pulse-line text-sm"></i>
              </div>
              <div>
                <p className="font-medium text-neutral-900 text-sm">Salud e Higiene</p>
                <p className="text-xs text-neutral-600 mt-1">El estudio cumple con toda la normativa sanitaria vigente. El cliente debe informar de cualquier condición médica relevante antes de la sesión. Nos reservamos el derecho a rechazar un servicio si consideramos que puede suponer un riesgo para la salud del cliente.</p>
              </div>
            </div>
            <div className="flex items-start gap-3 bg-neutral-50 rounded-lg p-4 border border-neutral-100">
              <div className="w-8 h-8 flex items-center justify-center bg-neutral-900 text-white rounded shrink-0">
                <i className="ri-refresh-line text-sm"></i>
              </div>
              <div>
                <p className="font-medium text-neutral-900 text-sm">Retoques</p>
                <p className="text-xs text-neutral-600 mt-1">Se ofrece un retoque gratuito dentro de los 3 meses posteriores a la realización del tatuaje, siempre que se hayan seguido correctamente las instrucciones de cuidado proporcionadas.</p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#enlaces" className="hover:text-amber-600 transition-colors">7. Enlaces Externos</a>
          </h4>
          <p>
            Este sitio web puede contener enlaces a sitios web de terceros (redes sociales, plataformas de reseñas, etc.). Daro Tattoo no se responsabiliza del contenido ni de las políticas de privacidad de dichos sitios externos. Le recomendamos revisar las condiciones de uso de cada sitio que visite.
          </p>
        </section>

        <section>
          <h4 className="text-base font-bold text-neutral-900 mb-3">
            <a href="#legislacion" className="hover:text-amber-600 transition-colors">8. Legislación Aplicable y Jurisdicción</a>
          </h4>
          <p>
            Las presentes condiciones se rigen por la <strong>legislación española</strong>. Para la resolución de cualquier controversia que pudiera derivarse del acceso o uso de este sitio web, las partes se someten a los Juzgados y Tribunales de <strong>Almería, España</strong>, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
          </p>
        </section>
      </div>
    </article>
  );
}
